/**
 * Dynamic toast utility to avoid pulling react-hot-toast into the main bundle.
 * Loads the library only when a toast is actually triggered.
 */

export const toast = {
  success: async (message: string) => {
    const { default: hotToast } = await import('react-hot-toast');
    hotToast.success(message);
  },
  error: async (message: string) => {
    const { default: hotToast } = await import('react-hot-toast');
    hotToast.error(message);
  },
  loading: async (message: string) => {
    const { default: hotToast } = await import('react-hot-toast');
    return hotToast.loading(message);
  },
  dismiss: async (toastId?: string) => {
    const { default: hotToast } = await import('react-hot-toast');
    hotToast.dismiss(toastId);
  },
};
